import { useCallback, useContext } from "react";

import { MaskedInput } from "~/components/TextInput";
import { setCorporalEvaluationImageIndex } from "~/modules/corporalEvaluation/services";
import { studentEvaluationDemoContext } from "~/pages/authenticated/personalTrainer/studentEvaluationDemo";

export const CoteWilmore: React.FC = () => {
	const { data } = useContext(studentEvaluationDemoContext);

	const handleAbdomenFocus = useCallback(() => {
		setCorporalEvaluationImageIndex(8);
	}, []);

	const handleRightFistFocus = useCallback(() => {
		setCorporalEvaluationImageIndex(9);
	}, []);

	return (
		<div className="flex gap-3">
			<MaskedInput
				label="Abdômen (cm)"
				mask="float"
				placeholder="0,0"
				value={data?.abdomen}
				onFocus={handleAbdomenFocus}
				onChange={() => undefined}
			/>
			<MaskedInput
				key={"rightFist-input"}
				label="Punho Direito (cm)"
				mask="float"
				value={data?.rightFist}
				placeholder="0,0"
				onFocus={handleRightFistFocus}
				onChange={() => undefined}
			/>
		</div>
	);
};
